import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const TowerIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M4 1.5C4 1.22386 4.22386 1 4.5 1H5C5.27614 1 5.5 1.22386 5.5 1.5V2.5C5.5 2.77614 5.72386 3 6 3H6.5C6.77614 3 7 2.77614 7 2.5V1.5C7 1.22386 7.22386 1 7.5 1H8.5C8.77614 1 9 1.22386 9 1.5V2.5C9 2.77614 9.22386 3 9.5 3H10C10.2761 3 10.5 2.77614 10.5 2.5V1.5C10.5 1.22386 10.7239 1 11 1H11.5C11.7761 1 12 1.22386 12 1.5V4C12 5.23223 11.2571 6.29094 10.1947 6.75267L10.7778 12H5.22222L5.80526 6.75267C4.74291 6.29094 4 5.23223 4 4V1.5Z"
		></path>
		<path
			fill="currentColor"
			d="M4 13C3.44772 13 3 13.4477 3 14V14.5C3 14.7761 3.22386 15 3.5 15H12.5C12.7761 15 13 14.7761 13 14.5V14C13 13.4477 12.5523 13 12 13H4Z"
		></path>
	</svg>
))
